import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import { colours } from './../helpers';
import DoughnutChartComponent from './DoughnutChartComponent';
import BadgeComponent from './BadgeComponent';

const pieSlices = [
  {
    label: 'Added Expected',
    colour: colours.colours.green
  },
  {
    label: 'Removed Expected',
    colour: colours.colours.green2
  },
  {
    label: 'Added Unexpected',
    colour: colours.colours.red
  },
  {
    label: 'Removed Unexpected',
    colour: colours.colours.peach
  }
];

const getPieData = (metrics) => [
  metrics.added.expected,
  metrics.removed.expected,
  metrics.added.unexpected,
  metrics.removed.unexpected
];

const InstallerStatsComponent = ({
  badge,
  metrics
}) => (
  <Col md={4} mdOffset={4}>
    <Row>
      <Col md={8} mdOffset={2}>
        <DoughnutChartComponent
          title="Installer"
          height={300}
          slices={pieSlices}
          data={getPieData(metrics)}
        />
      </Col>
    </Row>
    <Row>
      <Col md={12} style={{ paddingTop: '15px' }}>
        <BadgeComponent {...badge} />
      </Col>
    </Row>
  </Col>
);

InstallerStatsComponent.propTypes = {
  badge: PropTypes.shape({ style: PropTypes.string.isRequired }).isRequired,
  metrics: PropTypes.shape({
    added: PropTypes.shape({
      expected: PropTypes.number.isRequired,
      unexpected: PropTypes.number.isRequired
    }).isRequired,
    removed: PropTypes.shape({
      expected: PropTypes.number.isRequired,
      unexpected: PropTypes.number.isRequired
    }).isRequired,
  }).isRequired
};

export default InstallerStatsComponent;


// WEBPACK FOOTER //
// src/Components/InstallerStatsComponent.jsx